import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FileExplorer from "./FileExplorer";
import Paper from "@mui/material/Paper";
import { APIContext } from "../Contexts/APIContext";
import { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Line from "../Utilities/Line";
import { TelemetryContext } from "../Contexts/TelemetryContext";

export default function LegacyFilesContainer() {
    const navigate = useNavigate();
    const { get, getChart } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);
    const [licenseNum, setLicenseNum] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        get(`MyFiles`, `GetLegacyPath`, setLicenseNum)
    }, []);

    const getZipFolder = (container: string, folder: string) => {
        setLoading(true);
        const filename = folder.slice(1, folder.length - 1).replace("/", "_");

        getChart(`MyFiles`, `GetZipFolder?container=${container}&folderName=${folder}`, (objectUrl) => {
            const a = document.createElement('a');
            a.href = objectUrl;
            const name = filename.includes('.zip') ? filename : `${filename}.zip`;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);
            setLoading(false);
        });
    }

    const getZipFile = (container: string, path: string, extension: string) => {
        setLoading(true);

        get(`MyFiles`, `GetFile?container=${container}&path=${path}&extension=${extension}`, (url) => {
            window.open(url);
            setLoading(false);
        });
    }

    return (
        <Grid container alignItems="flex-start">
            <Grid size={12}>
                <Typography variant="h4">Legacy Files</Typography>
            </Grid>
            {licenseNum === null &&
                <Grid size={12}>
                    <Typography variant="h6">No legacy files available for this account.</Typography>
                </Grid>
            }
            <Grid size={4} container>
                {(licenseNum && licenseNum.length > 0) &&
                    <Grid size={12} component={Paper} container>
                        <Grid size={12}>
                            <Typography gutterBottom>Saved Sessions can only be restored into the version that created the session. For example, if the session was created with TRICS 7.2.4 then you can only view this session with TRICS 7.2.4 Offline on your PC. When downloading the Session file you should save it in the following destination folder on your PC where 'nnnnnn' is your TRICS licence number and the TRICS folder matches the version in the file name.</Typography>
                            <Typography gutterBottom>Destination Folder: C:\Program Files\Trics7114\Files\nnnnnn</Typography>
                            <Typography gutterBottom>For 64 Bit Windows versions, use C:\Program Files (x86)\Trics7114\Files\nnnnnn</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Button disabled={loading} onClick={() => getZipFolder('legacy', `/Sessions/${licenseNum}/`)}>Download All Session Files</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button disabled={loading} onClick={() => getZipFolder('legacy', `/Reports/${licenseNum}/`)}>Download All Report Files</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={() => navigate("/softwarearchive")} variant="outlined">Offline Software Archive</Button>
                        </Grid>
                    </Grid>
                }
                <Grid container size={12} component={Paper}>
                    <Grid size={12}>
                        <Typography variant="h6">Research Reports</Typography>
                    </Grid>
                    <Line />
                    <Grid size={12}>
                        <Typography gutterBottom>Click on the button below to download a 96mb zip file (Trics7114reports.zip) to your PC. After downloading, unzip the contents of the zip file and run the included executable (Trics7114reports.exe) to install TRICS 7.11.4 reports on your PC.</Typography>
                        <Typography gutterBottom><i>Note that these reports are only required for Offline Version users who have very slow or no internet access. Requires TRICS 7.11.4 Off-Line Version to be already installed.</i></Typography>
                    </Grid>
                    <Grid size={12}>
                        <Button disabled={loading} onClick={() => {
                            logFileAccess('trics7114reports.zip', 'LegacyResearchReports');
                            getZipFile('trics', `/OfflineReports/trics7114reports`, 'zip');
                        }}>Download Research Reports</Button>
                    </Grid>
                </Grid>
            </Grid>
            {(licenseNum && licenseNum.length > 0) &&
                <>
                    <Grid size={4} component={Paper}>
                        <FileExplorer title="Reports" container="legacy" rootPath={`/Reports/${licenseNum}/`} legacy />
                    </Grid>
                    <Grid size={4} component={Paper}>
                        <FileExplorer title="Sessions" container="legacy" rootPath={`/Sessions/${licenseNum}/`} legacy />
                    </Grid>
                </>
            }
        </Grid>
    );
}
